import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import i18n from './i18n'
import './assets/css/global.css'
import './assets/css/mystyle.css'
import _ from 'lodash'
import axios from 'axios'

Vue.config.productionTip = false

axios.defaults.withCredentials = true
i18n.init()

Vue.prototype.$http = axios

Vue.prototype.$_ = _

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
